import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

let _supabase: SupabaseClient | null = null;

if (supabaseUrl && supabaseAnonKey) {
  _supabase = createClient(supabaseUrl, supabaseAnonKey);
} else {
  console.warn(
    'Missing Supabase environment variables (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY). ' +
    'Database features will be unavailable.'
  );
}

// Export as non-nullable for convenience; guarded at call sites where needed
export const supabase = _supabase as SupabaseClient;

export type Profile = {
  id: string;
  email: string;
  role: 'admin' | 'user';
  full_name?: string;
  avatar_url?: string;
  city?: string;
  postcode?: string;
  street_name?: string;
  country?: string;
  phone_number?: string;
  created_at: string;
  updated_at: string;
};
